import React, { useEffect, useMemo, useRef, useState } from "react";
import styles from '../styles/transactionList.module.scss'
import { useTranslation } from "react-i18next";


const TransactionList = ({ lists }) => {
  const { t } = useTranslation('record')

  const items=[t('transactionType'), t('time'), t('amount'), t('status')]
  return(
    <div className={styles.transactionList}>
      <div className={styles.title}>
        {items.map((v,index)=>{
          return <div key={index} className={styles.item}>{v}</div>
        })}
      </div>

      <div className={styles.content}>
        {lists?.map((v,index)=>{

          let moneyTitle = t('rmb');
          if (v.withdrawalWay == 2) {
            moneyTitle = '（USDT）';
          } else if (v.withdrawalWay == 23) {
            moneyTitle = '（USD）';
          }

          if (v.transType == 9) {
            if (v.payType == 1) {
              moneyTitle = '（USDT）';
            } 
          }

          return <div key={index} className={styles.list}>
            <div className={styles.dealType}>
              <div>{v.dealType} <span>{moneyTitle}</span></div>
              {v.outAccount &&
                <div>
                  <span>{v.outAccount}</span> 
                  →
                  <span>{v.intoAccount}</span>
                </div> 
              } 
            </div>

            <div>{v.createAt}</div>

            <div className={styles.amount}>{(v.withdrawalWay == 23 ? v.usdtAmount : v.amount).toFixed(2)}</div>

            <div className={styles.statusName}>{v.statusName}</div>
          </div>
        })}
      </div>
    </div>
  )
}

export default TransactionList